import { render } from "./BuyView.vue?vue&type=template&id=11fc18c1"
import script from "./BuyView.vue?vue&type=script&lang=js"
export * from "./BuyView.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__